import { render, staticRenderFns } from "./AppDesktop.vue?vue&type=template&id=361c208a&scoped=true"
import script from "./AppDesktop.vue?vue&type=script&lang=js"
export * from "./AppDesktop.vue?vue&type=script&lang=js"
import style0 from "./AppDesktop.vue?vue&type=style&index=0&id=361c208a&prod&scoped=true&lang=scss"
import style1 from "./AppDesktop.vue?vue&type=style&index=1&id=361c208a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361c208a",
  null
  
)

export default component.exports